import React from 'react';

import { Field, useField } from 'formik';
import { InputLabel, TextField } from '@mui/material';

interface TextFieldProps {
  label: any;
  name: string;
  maxChar?: number;
  readOnly?: boolean;
  disabled?: boolean;
  customValue?: string;
  customError?: any;
  placeholder?: string;
  showCharacterCount?: boolean;
  rowCount?: number;
  propFormikContext?: any;
  customId?: string;
  customInputProps?: any;
  customType?: string;
  multiline?: boolean;
  backgroundColor?: string;
  isMandatory?: boolean;
}

const ValidatedTextField: React.FC<TextFieldProps> = (props) => {
  const { label, maxChar = 255 } = props;
  const [field, meta] = useField<unknown>(props);
  if (props.customValue) {
    field.value = props.customValue;
  }
  if (!field.value) {
    field.value = '';
  }
  let errorText = meta.error && meta.touched ? meta.error : '';
  if (props.customError) {
    errorText = props.customError;
  }

  return (
    <>
      <InputLabel required={props.isMandatory} disabled={props.disabled} error={!!errorText}>
        {label}
      </InputLabel>
      <Field
        variant="filled"
        rows={props.rowCount}
        type={props.customType ?? 'text'}
        multiline={props.rowCount !== 1 || props.multiline}
        id={props.customId ?? `${props.name}-text-input`}
        data-testid={`${props.name}-text-input`}
        aria-label={`${props.name}-text-input-aria-label`}
        as={TextField}
        helperText={
          errorText ||
          (props.showCharacterCount &&
            (field.value ? `${field.value.toLocaleString().length}/${props.maxChar}` : `0/${props.maxChar}`))
        }
        errortext={errorText}
        inputProps={{
          id: props.customId ?? `${props.name}-text-input`,
          maxLength: maxChar,
          placeholder: props.placeholder,
          readOnly: props.readOnly,
          disabled: props.disabled,
          style: { backgroundColor: props.backgroundColor },
        }}
        InputProps={props.customInputProps ?? { disableUnderline: true }}
        {...field}
        fullWidth
        error={!!errorText}
      />
    </>
  );
};

export default ValidatedTextField;
